import { z } from 'zod';

export const ShippingInformation = z.object({
	address1: z.string(),
	address2: z.string().optional(),
	city: z.string(),
	state: z.string(),
	postalCode: z.string(),
	country: z.string(),
	phoneNumber: z.string(),
});

export type ShippingInformation = z.infer<typeof ShippingInformation>;
